// src/components/Footer.js

import React from 'react';
import {
  Box,
  Container,
  Stack,
  Text,
  Link,
  SimpleGrid,
  VStack,
  HStack,
  Icon,
  Divider,
} from '@chakra-ui/react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import VisitorCounter from './VisitorCounter';

const Footer = () => {
  const policies = [
    {
      label: 'นโยบายเว็บไซต์',
      href: 'https://dld.go.th/webnew/index.php?view=article&id=505:nyobay-kar-hi-brikar-websit-khxng-krm-psusatw&catid=569',
    },
    {
      label: 'นโยบายการรักษาความมั่นคงปลอดภัย',
      href: 'https://dld.go.th/webnew/images/stories/policy/krut_policycyber_dld2566.pdf',
    },
    {
      label: 'นโยบายการคุ้มครองข้อมูลส่วนบุคคล',
      href: 'https://dld.go.th/webnew/images/stories/policy/PDPA_Policy.pdf',
    },
    {
      label: 'นโยบายการใช้คุกกี้',
      href: 'https://dld.go.th/webnew/index.php?view=article&id=508:nyobay-kar-chi-khukki-khxng-krm-psusatw&catid=569',
    },
  ];

  return (
    <Box
      as="footer"
      bgGradient="linear(to-r, primary.800, primary.900)" 
      color="gray.200"
      py={{ base: 6, md: 10 }}
    >
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
          {/* Column 1: Contact Info */}
          <VStack spacing={4} align="start">
            <Text fontSize="lg" fontWeight="bold" color="white">
              สำนักเทคโนโลยีชีวภัณฑ์สัตว์ กรมปศุสัตว์
            </Text>
            <VStack spacing={2} align="start" fontSize="sm">
              <HStack>
                <Icon as={FaMapMarkerAlt} w={4} h={4} />
                <Text>1213 หมู่ 11 ต.ปากช่อง อ.ปากช่อง จ.นครราชสีมา 30130</Text>
              </HStack>
              <HStack>
                <Icon as={FaPhone} w={4} h={4} />
                <Link href="tel:044311476">044311476 ต่อ 1140</Link>
              </HStack>
              <HStack>
                <Icon as={FaEnvelope} w={4} h={4} />
                <Link href="mailto:biologic@dld.go.th">biologic@dld.go.th</Link>
              </HStack>
            </VStack>
          </VStack>

          {/* Column 2: Policy Links */}
          <VStack spacing={4} align={{ base: 'start', md: 'end' }}>
             <Text fontSize="lg" fontWeight="bold" color="white">
              นโยบายและข้อกำหนด
            </Text>
            <VStack spacing={2} align={{ base: 'start', md: 'end' }} fontSize="sm">
              {policies.map((policy) => (
                <Link 
                  key={policy.label} 
                  href={policy.href} 
                  isExternal
                  _hover={{ textDecoration: 'underline', color: 'white' }}
                >
                  {policy.label}
                </Link>
              ))}
            </VStack>
          </VStack>
        </SimpleGrid>

        <Divider my={6} borderColor="gray.600" />

        <VisitorCounter />

        <Text pt={4} fontSize="sm" textAlign="center">
          สงวนลิขสิทธิ์ พ.ศ. 2568 ตามพระราชบัญญัติลิขสิทธิ์ 2537
        </Text>
      </Container>
    </Box>
  );
};

export default Footer;